module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.loading == true) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading Details"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.loading == false) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.checkedMessage == true) ? _c('small', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "20px"
    }
  }, [_c('strong', [_vm._v("Please Note:")]), _vm._v(" You will only be able to advance a status passed \"Checked Out\" once that status has been reached.")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Updated Status")]), _vm._v(" "), _c('v-select', {
    staticClass: "colorSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "items": _vm.popupStatus,
      "label": _vm.globalModalParams.currentStatus,
      "item-value": "text",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncShowReasons
    },
    model: {
      value: (_vm.newStatus),
      callback: function($$v) {
        _vm.newStatus = $$v
      },
      expression: "newStatus"
    }
  }), _vm._v(" "), _c('br'), (_vm.newStatus != this.globalModalParams.currentStatus) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Please select a reason for status change before proceeding")]) : _vm._e(), _vm._v(" "), (_vm.newStatus != this.globalModalParams.currentStatus && _vm.reasons.length > 0) ? _c('v-select', {
    staticClass: "colorSelectBlack",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "id": "reasonSelect",
      "items": _vm.reasons,
      "item-value": "text",
      "label": "Select Reason",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncChangeReason
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newStatus != this.globalModalParams.currentStatus && (_vm.reasons.length == 0 || _vm.reason == 'Other')),
      expression: "newStatus != this.globalModalParams.currentStatus && ( reasons.length == 0 || reason == 'Other' )"
    }],
    attrs: {
      "id": "statusComments",
      "rows": "3",
      "multi-line": "",
      "clearable": "",
      "label": "Enter your reason here",
      "solo": ""
    },
    model: {
      value: (_vm.additionalComments),
      callback: function($$v) {
        _vm.additionalComments = $$v
      },
      expression: "additionalComments"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.fncCheckIfUpdate()
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateQuoteStatus()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}